import React from 'react'
import './Home.module.css'
import 'bootstrap/dist/css/bootstrap.min.css'
const AboutReliable = () => {
    return (
        <>

            <section className="section-sp1 mid-light">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className='text-center title-head'>About Reliable</h1>
                            <p style={{ textAlign: "justify", lineHeight: 2 }}>Reliable Institute, a journey towards Excellence. It was founded on 8th February 2020 by Ex - VPs , HODs & Senior Faculties with a vision to provide excellent career education to the students with a perfect blend of high quality academics, stable & highly experienced faculty team, positive & conducive environment for learning, regular analysis of student's performance, personal care & attention to all students. Reliable Institute has a robust Academic & Management team which can adapt to any change which takes place in the pattern of JEE or any other competitive entrance examination.</p>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default AboutReliable